<template lang="html">
  <div class="test-group-question-answer" v-if="answer">
    <input type="checkbox" @change="change" :checked="isChosen" class="checkbox" :id="'answer' + answer.id">
    <label :for="'answer' + answer.id" class="test-group-question-answer-body"></label>
    <label :for="'answer' + answer.id" class="margin_left">{{ body }}</label>
  </div>
</template>

<script>
  export default {
    name: 'interview-test-group-question-answer',

    components: {
    },

    props: {
      question: Object,
      answer: Object,
      answerChange: Function
    },

    data () {
      return {
      }
    },

    methods: {
      change (event) {
        if (event.target.checked === false) {
          // this to prevent possible decheckout of already seleced answer
          // make checkbox working as a radio button
          event.target.checked = true
        } else {
          this.answerChange(this.question, this.answer)
        }
      }
    },

    computed: {
      body () {
        return this.answer ? this.answer.body : void 0
      },

      isChosen () {
        return Boolean(this.answer ? this.answer.is_chosen : void 0)
      }
    },

    beforeMount () {
    }
  }
</script>

<style lang="scss" scoped>
 .test-group-question-answer {
   padding: 4px 0px;
   display: flex;
   align-items: center;
 }
 .margin_left {
   margin-left: 5px;
 }
</style>
